var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$accessor.ipfs.appCID)?_c('p',{directives:[{name:"tippy",rawName:"v-tippy"},{name:"clipboard",rawName:"v-clipboard",value:(_vm.$accessor.ipfs.appCID),expression:"$accessor.ipfs.appCID"}],staticClass:"cid",attrs:{"title":"Current version. Click to copy."}},[_vm._v("\n  "+_vm._s(_vm.$accessor.ipfs.appCID)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }